import React from 'react';
import { FormControl, TextField } from '@mui/material';
import WorkflowSessionModalButton from './WorkflowSessionModalButton';

const BearerTokenFields = ({
    t,
    tokenName,
    disableControl,
    fontWeights,
    onInputChange,
    setTokenName,
    screen,
    setWorkflowSessionModal,
    setValueLabel,
}) => {
    return (
        <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("TOKEN_NAME")}
                    type="text"
                    value={tokenName || ''}
                    disabled={disableControl || false}
                    inputProps={{
                        style: { fontWeight: fontWeights.tokenName }
                    }}
                    onChange={(e) => {
                        onInputChange('TOKEN_NAME', e.target.value);
                        setTokenName(e.target.value);
                    }}
                    className={"width-100"}
                    name={"TOKEN_NAME"}
                    autoComplete="off"
                />
            </FormControl>
            {["GET_DATA", "SEND_DATA"].includes(screen) && (
                <WorkflowSessionModalButton
                    disableControl={disableControl || false}
                    label={t("TOKEN_NAME")}
                    setWorkflowSessionModal={setWorkflowSessionModal}
                    setValueLabel={setValueLabel}
                />
            )}
        </div>
    );
};

export default BearerTokenFields;

